import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { S3UploadService } from 'src/app/services/s3-upload.service';
import { SignaturePad } from 'angular2-signaturepad';

@Component({
  selector: 'app-course-signature-pad',
  templateUrl: './course-signature-pad.component.html',
  styleUrls: ['./course-signature-pad.component.scss']
})
export class CourseSignaturePadComponent implements OnInit {

  @ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;

  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 2,
    'canvasWidth': 500,
    'canvasHeight': 500
  };

  imgData: string;
  canvas: HTMLCanvasElement;
  loading: boolean = false;
  testdata: any;
  displayMsg: boolean;

  constructor(
    public _s3UploadService: S3UploadService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.canvas = document.querySelector("canvas");
    this.setCanvasSize();
  }

  ngAfterViewInit() {
    this.signaturePad.clear();
  }

  clear() {

    console.log('Clear Calling');

    this.imgData = null
    this.signaturePad.clear();
  }

  drawComplete() {
    this.imgData = this.signaturePad.toDataURL('image/png');
    // this.trimCanvas(this.canvas);
    console.log("Trimmed image data:", this.imgData);
  }

  drawStart() {
    console.log('Begin drawing');
  }

  trimCanvas(c) {
    let ctx = c.getContext('2d'),
      copy = document.createElement('canvas').getContext('2d'),
      pixels = ctx.getImageData(0, 0, c.width, c.height),
      l = pixels.data.length,
      i,
      bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
      },
      x, y;

    // Iterate over every pixel to find the highest
    // and where it ends on every axis ()
    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~((i / 4) / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }


    console.log("TRIM HEIGHT AND WIDTH", bound.left, bound.top, bound.right - bound.left, bound.bottom - bound.top)

    // Calculate the height and width of the content
    let trimHeight = bound.bottom - bound.top,
      trimWidth = bound.right - bound.left,
      trimmed = ctx.getImageData(bound.left || 500, bound.top || 500, trimWidth || 500, trimHeight || 500);
    console.log("trimmed", trimmed)
    //  this.testdata = trimmed.data
    copy.canvas.width = trimWidth;
    copy.canvas.height = trimHeight;
    copy.putImageData(trimmed, 0, 0);

    // Return trimmed canvas
    console.log('copy.canvas;', copy.canvas.toDataURL())
    console.log(" copy.putImageData(trimmed, 0, 0);", copy.putImageData(trimmed, 0, 0))
    this.testdata = copy.canvas.toDataURL()
    return copy.canvas;
  }


  private setCanvasSize() {
    let screenWidth = screen.width;
    if (screenWidth > 767) {
      this.resizeCanvas(500, 500);
    } else if (screenWidth < 767 && screenWidth >= 575) {
      this.resizeCanvas(420, 420);
    } else if (screenWidth < 575 && screenWidth >= 420) {
      this.resizeCanvas(350, 350);
    } else if (screenWidth < 420 && screenWidth >= 380) {
      this.resizeCanvas(300, 300);
    } else if (screenWidth < 380) {
      this.resizeCanvas(260, 260);
    }
  }

  private resizeCanvas(width: number, height: number) {
    this.canvas.width = width;
    this.canvas.height = height;
  }


  submit() {
    this.loading = true
    this.displayMsg = false
    if (!this.signaturePad.isEmpty()) {
      console.log("DATA TO BE SEND", this.testdata)
      this._s3UploadService.uploadSignatureBase64(this.imgData).subscribe(res => {
        console.log("res in signature ==> ", res)
        this.dialogRef.close(res.Location)
        this.loading = false
      })
    }
    else {
      this.loading = false
      this.displayMsg = true
    }
    // this.dialogRef.close(this.testdata)
    // if(this.signaturePad.isEmpty()){
    //   alert("IS EMPTY")
    // }
    // else{
    //   this.dialogRef.close(this.testdata)
    // }
  }

}
